import { Dropdown } from '@/components/dropdown'
import PropTypes from 'prop-types'

const DropDownContainer = ({ label, options, placeholder, id, formik, fieldInfo, disabled, description }) => {
  const updateValueArray = value => {
    const arr = formik.values[fieldInfo.key]
    arr[fieldInfo.index][id] = value
    return arr
  }

  const value = fieldInfo ? formik.values[fieldInfo.key][fieldInfo.index][id] : formik.values[id]

  const onChange = value =>
    fieldInfo ? formik.setFieldValue(fieldInfo.key, updateValueArray(value)) : formik.setFieldValue(id, value)
  const fieldError =
    fieldInfo && formik.errors[fieldInfo.key] && formik.errors[fieldInfo.key][fieldInfo.index]
      ? formik.errors[fieldInfo.key][fieldInfo.index][id]
      : formik.errors[id]
  const fieldTouched =
    fieldInfo && formik.touched[fieldInfo.key] && formik.touched[fieldInfo.key][fieldInfo.index]
      ? formik.touched[fieldInfo.key][fieldInfo.index][id]
      : formik.touched[id]

  return (
    <Dropdown
      label={label}
      options={options}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={fieldTouched && fieldError ? 'border-[--error-300]' : ''}
      fieldDescription={description}
      helpText={
        fieldTouched && fieldError ? <p className="text-sm font-normal text-[--error-500]">{fieldError}</p> : null
      }
      disabled={disabled}
    />
  )
}

DropDownContainer.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })),
  placeholder: PropTypes.string,
  id: PropTypes.string,
  formik: PropTypes.object,
  fieldInfo: PropTypes.shape({ index: PropTypes.number, key: PropTypes.string }),
  disabled: PropTypes.bool,
  description: PropTypes.string,
}

export { DropDownContainer }
